<template>
  <kst-container class="kst-RtnInvoice-details">
    <kst-form
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :loading="isLoading"
      :title="title"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>

      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Invoice :data="data"/>
          <Details :data="data"/>
          <Items :data="data" :items="data.Items"/>
          <Total :data="data"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../RtnInvoiceInfo.js";
import Model from "../RtnInvoiceModel.js";
import Services from "../RtnInvoiceServices.js";

import Action from "./RtnInvoiceDetails_Action";
import Details from "./RtnInvoiceDetails_Details";
import Invoice from "./RtnInvoiceDetails_Invoice";
import Items from "./RtnInvoiceDetails_Items";
import Total from "./RtnInvoiceDetails_Total";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details,
    Invoice,
    Items,
    Total
  },
  data: () => ({
    data: {},
    isLoading: false,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details
    },
    // error
    failureInit: null,
    formWarnings: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails(id) {
      const config = Services.getRtnInvoiceDetails(id);
      this.runAxios(config, null,
        this.loadDetails_Success,
        this.loadDetails_Error,
        this.loadDetails_Invalid
      );
    },
    loadDetails_Success(data) {
      this.setDetails(data);
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },
    loadDetails_Invalid(message) {
      this.formWarnings = [message];
      this.initLoad_End();
    },

    setDetails(data) {
      this.data = data;
      // normalize field
      this.data.DiscType = null;

      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
      }
    }
  }
}
</script>